module.exports = __webpack_public_path__ + "img/image-about-us-02-academy-template.9b5b3174.jpg";